import { render, staticRenderFns } from "./SingleUSSupplies.vue?vue&type=template&id=688230d4&scoped=true&"
import script from "./SingleUSSupplies.vue?vue&type=script&lang=js&"
export * from "./SingleUSSupplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688230d4",
  null
  
)

export default component.exports